import {Component} from 'react'
import { connect } from 'react-redux'
import MailingForm from "../../../Forms/MailingForm/MailingForm.jsx"

class MailingList extends Component {
  render() {
    return (
      <div>
        <MailingForm
          email={this.props.user}
          onSubmit={this.sendMail}
          initialValues={{
            email: this.props.user.email,
            user: this.props.user,
            freelance: this.props.freelance,
            admin: this.props.admin,
            mail: "1"
          }}
        />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    admin: state.currentUser.user,
  })
)(MailingList)